import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show d-block",
  style: {"background":"rgba(0, 0, 0, 0.5)"},
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "card bg-light border-warning" }
const _hoisted_9 = { class: "card-body py-2" }
const _hoisted_10 = { class: "d-flex justify-content-between" }
const _hoisted_11 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_12 = { class: "badge bg-warning" }
const _hoisted_13 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_14 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "row g-2 mb-2" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = ["value", "disabled"]
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = ["value", "disabled"]
const _hoisted_25 = ["value"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "modal-footer" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_32 = {
  key: 1,
  class: "fas fa-link me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MediaDisplay = _resolveComponent("MediaDisplay")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "modal-title" }, "Vincular Mensaje Huérfano", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                disabled: _ctx.isLinking
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-muted" }, " Seleccione la alerta original a la cual pertenece este mensaje. ", -1)),
              _createElementVNode("div", _hoisted_7, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label fw-bold" }, "Mensaje a Vincular:", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.sourceMessage)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.formatDateTime(_ctx.sourceMessage.date)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_12, "#" + _toDisplayString(_ctx.sourceMessage?.messageId), 1)
                    ]),
                    (_ctx.sourceMessage?.text)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.sourceMessage.text), 1))
                      : _createCommentVNode("", true),
                    (
                    _ctx.sourceMessage?.mediaType &&
                    _ctx.sourceMessage?.mediaType !== 'none'
                  )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_MediaDisplay, {
                            "media-type": _ctx.sourceMessage.mediaType || 'none',
                            "storage-path": _ctx.sourceMessage.storagePath,
                            style: {"max-width":"200px"}
                          }, null, 8, ["media-type", "storage-path"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label fw-bold" }, "Tipo de Vinculación:", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLinkType) = $event)),
                  disabled: _ctx.isLinking
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkTypes, (type) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: type.value || 'auto',
                      value: type.value
                    }, _toDisplayString(type.label), 9, _hoisted_17))
                  }), 128))
                ], 8, _hoisted_16), [
                  [_vModelSelect, _ctx.selectedLinkType]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("small", { class: "text-muted d-block mt-1" }, " \"Automático\" intentará detectar si hay cuotas o resultados. ", -1))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label fw-bold" }, "Buscar Alerta Padre:", -1)),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("select", {
                      class: "form-select form-select-sm",
                      value: _ctx.selectedMonth,
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (
                    _ctx.$emit(
                      'update:selectedMonth',
                      +($event.target as HTMLSelectElement).value
                    )
                  )),
                      disabled: _ctx.isLinking
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: index
                        }, _toDisplayString(month), 9, _hoisted_22))
                      }), 128))
                    ], 40, _hoisted_21)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("select", {
                      class: "form-select form-select-sm",
                      value: _ctx.selectedYear,
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (
                    _ctx.$emit(
                      'update:selectedYear',
                      +($event.target as HTMLSelectElement).value
                    )
                  )),
                      disabled: _ctx.isLinking
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: year,
                          value: year
                        }, _toDisplayString(year), 9, _hoisted_25))
                      }), 128))
                    ], 40, _hoisted_24)
                  ])
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("small", { class: "text-muted d-block mb-2" }, " Filtra por fecha para encontrar alertas del mes pasado. ", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTargetAlertId) = $event)),
                  class: "form-select",
                  size: "10",
                  disabled: _ctx.isLinking
                }, [
                  _cache[11] || (_cache[11] = _createElementVNode("option", {
                    disabled: "",
                    value: ""
                  }, "Seleccione una alerta...", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetAlerts, (alert) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: alert.alertId,
                      value: alert.mainMessage.messageId
                    }, " [#" + _toDisplayString(alert.mainMessage.messageId) + "] " + _toDisplayString(_ctx.formatDate(alert.mainMessage.date)) + " - " + _toDisplayString(alert.mainMessage.sport) + " " + _toDisplayString(alert.mainMessage.teams
                    ? alert.mainMessage.teams.join(" vs ")
                    : "") + " - " + _toDisplayString(alert.mainMessage.selection), 9, _hoisted_27))
                  }), 128))
                ], 8, _hoisted_26), [
                  [_vModelSelect, _ctx.selectedTargetAlertId]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close'))),
                disabled: _ctx.isLinking
              }, " Cancelar ", 8, _hoisted_29),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args))),
                disabled: !_ctx.selectedTargetAlertId || _ctx.isLinking
              }, [
                (_ctx.isLinking)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31))
                  : (_openBlock(), _createElementBlock("i", _hoisted_32)),
                _cache[15] || (_cache[15] = _createTextVNode(" Confirmar Vinculación ", -1))
              ], 8, _hoisted_30)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}